module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar mailingAttributes = (resourceData || {}).attributes || {};\nvar sendStatus = mailingAttributes.sendStatus || ''\nvar resendGranted = false;\nif((storage || {}).user){\nresendGranted = storage.user.hasRoleOption('resendGranted', (config || {}).roleOptionScope || 'newsletter');\n}\nvar statsRecipients = (mailingAttributes.statsRecipients || 0) * 1;\n%>\n<div class=\"buttons\">\n<div class=\"left\">\n<%\nif (!sendStatus || sendStatus === 'draft') {\n%><%- include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'delete', context: 'mailing', mode: '', symbolOnly: true } }); %><%\n}\n%><%- include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showPreview', context: 'mailing', mode: '', symbolOnly: true } }); %><%\n%><%- include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showDuplicate', context: 'mailing', mode: '', symbolOnly: true } }); %><%\nif(resendGranted){\n%><%- include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'resend', context: 'mailing', mode: '', symbolOnly: true } }); %><%\n}\n%>\n</div>\n<div class=\"right\">\n<%\nif (sendStatus === 'draft' && statsRecipients > 0) {\n%><%- include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'schedule', context: 'mailing', mode: '', symbolOnly: false } }); %><%\n} else if (sendStatus === 'scheduled') {\n%><%- include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'unschedule', context: 'mailing', mode: '', symbolOnly: false } }); %>    <%\n} else if (sendStatus === 'sending') {\n%><%- include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'abort', context: 'mailing', mode: '', symbolOnly: false } }); %><%\n}\n%>\n</div>\n</div>"
  , __filename = "components/templates/newsletter/mailings/table/customColActions.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var mailingAttributes = (resourceData || {}).attributes || {};
var sendStatus = mailingAttributes.sendStatus || ''
var resendGranted = false;
if((storage || {}).user){
resendGranted = storage.user.hasRoleOption('resendGranted', (config || {}).roleOptionScope || 'newsletter');
}
var statsRecipients = (mailingAttributes.statsRecipients || 0) * 1;

    ; __line = 9
    ; __append("\n<div class=\"buttons\">\n<div class=\"left\">\n")
    ; __line = 12
    ; 
if (!sendStatus || sendStatus === 'draft') {

    ; __line = 14
    ; __append( include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'delete', context: 'mailing', mode: '', symbolOnly: true } }) )
    ; 
}

    ; __line = 16
    ; __append( include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showPreview', context: 'mailing', mode: '', symbolOnly: true } }) )
    ; 

    ; __line = 17
    ; __append( include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showDuplicate', context: 'mailing', mode: '', symbolOnly: true } }) )
    ; 
if(resendGranted){

    ; __line = 19
    ; __append( include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'resend', context: 'mailing', mode: '', symbolOnly: true } }) )
    ; 
}

    ; __line = 21
    ; __append("\n</div>\n<div class=\"right\">\n")
    ; __line = 24
    ; 
if (sendStatus === 'draft' && statsRecipients > 0) {

    ; __line = 26
    ; __append( include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'schedule', context: 'mailing', mode: '', symbolOnly: false } }) )
    ; 
} else if (sendStatus === 'scheduled') {

    ; __line = 28
    ; __append( include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'unschedule', context: 'mailing', mode: '', symbolOnly: false } }) )
    ; __append("    ")
    ; 
} else if (sendStatus === 'sending') {

    ; __line = 30
    ; __append( include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'abort', context: 'mailing', mode: '', symbolOnly: false } }) )
    ; 
}

    ; __line = 32
    ; __append("\n</div>\n</div>")
    ; __line = 34
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/newsletter/mailings/table/customColActions.ejs

}